import _ from "lodash";

export interface ViewContext {
  metric?: string;
  groupBy?: string;
  compareBy?: string;
  view?: string;
  startDate?: string;
  endDate?: string;
  numPublications?: string;
  [key: string]: number | string;
}

export interface UserContext {
  userID?: number;
  userType?: string;
  [key: string]: string | number | any;
}

export interface GAContextProps {
  gaUserContext: UserContext;
  gaViewContext: ViewContext;
  merchantName?: string;
}

// Wrapper for sending google analytics events.
export const sendGAEvent = (
  category: string,
  action: string,
  label: string,
  dimensions: any
) => {
  const analytics = (window as any).ga;
  const customDimensions = formatCustomDimensions(dimensions);

  // Send GA beacon
  analytics("send", "event", category, action, label, customDimensions);
};

export const formatCustomDimensions = (dimensions: UserContext & ViewContext) =>
  _.keys(dimensions).reduce((obj: any, key: string) => {
    const dimensionIndex = GA_CUSTOM_DIMENSION_KEY[key];
    if (dimensionIndex) obj[dimensionIndex] = dimensions[key];
    return obj;
  }, {});

// Map custom dimension name to the index corresponding to the
// same Google Analytics custom dimension.
export const GA_CUSTOM_DIMENSION_KEY: { [key: string]: string } = {
  userType: "dimension1",
  userID: "dimension2",
  view: "dimension3",
  groupBy: "dimension4",
  compareBy: "dimension5",
  startDate: "dimension6",
  endDate: "dimension7",
  numPublications: "dimension8",
  metric: "dimension9",
  deviceFilters: "dimension10",
  channelFilters: "dimension11",
  userAvailableMerchants: "dimension12"
};



// WEBPACK FOOTER //
// ./client/modules/common/google_analytics.ts